module.exports = __webpack_public_path__ + "img/iconfinder_edit-document-note-writing-review_3209355.bc277d55.svg";